import async from 'components/Async';
import { accessType, role } from 'constants/index';
import lodash from 'lodash';

const BaseTablePage = async(() => import('./BaseTablePage'));

const tempRouteList = [
   {
      path: '/temp/base-table',
      component: BaseTablePage,
   },
];

const access = {
   type: accessType.role,
   value: {
      partner: [
         role.partner.admin,
         role.partner.employerCentralExternal,
         role.partner.employerCentralInternal,
      ],
   },
};

const routeList = tempRouteList.map((routeItem) => ({
   ...routeItem,
   access: lodash.cloneDeep(access),
}));

export default routeList;
